import { render, staticRenderFns } from "./TutorTable.vue?vue&type=template&id=3830706c"
import script from "./TutorTable.vue?vue&type=script&lang=js"
export * from "./TutorTable.vue?vue&type=script&lang=js"
import style0 from "./TutorTable.vue?vue&type=style&index=0&id=3830706c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports